export class MPAPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "MPAEntityType",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
